import { Api } from "../api";

export class AppApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getMyApp() {
    try {
      const response = await this.api.instance.get("/apps/my-app");
      if (!(response.status === 200)) {
        return { kind: "error" };
      }
      const { data } = response;
      return { kind: "ok", data };
    } catch (e) {
      return { kind: "bad-data" };
    }
  }
  async patchMyApp(form: any) {
    try {
      const response = await this.api.instance.patch("/apps/my-app", form);
      if (!(response.status === 204)) {
        return { kind: "error" };
      }
      const { data } = response;
      return { kind: "ok", data };
    } catch (e) {
      return { kind: "bad-data" };
    }
  }
}
